export type PossibleRegionEnvs =
  | 'prodeu1'
  | 'prod'
  | 'prodcan1'
  | 'prodaus1'
  | 'dev'
  | 'sandbox'
  | 'mine';

const possibleRegionEnvs: PossibleRegionEnvs[] = [
  'prodeu1',
  'prodcan1',
  'prodaus1',
  'prod',
  'dev',
  'sandbox',
];

export const getRegionFromHeliumUrl = (url: string): PossibleRegionEnvs => {
  for (let envIdx = 0; envIdx < possibleRegionEnvs.length; envIdx += 1) {
    if (url.includes(`.${possibleRegionEnvs[envIdx]}.`)) {
      return possibleRegionEnvs[envIdx];
    }
  }

  return 'mine';
};
